import { colors } from 'component-library/styles/colors';
import { SpacingProps, spacingStyles } from 'component-library/styles/spacing';
import styled from 'styled-components';

interface CircleProps extends SpacingProps {
  small?: boolean;
  backgroundColor?: string;
  borderColor?: string;
}

export const Circle = styled.div<CircleProps>`
  background-color: ${({ backgroundColor = colors.navyBlue }) =>
    backgroundColor};
  border: ${({ borderColor = 'transparent' }) => `1px solid ${borderColor}`};
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  width: ${({ small = false }) => (small ? '24px' : '40px')};
  height: ${({ small = false }) => (small ? '24px' : '40px')};
  min-width: ${({ small = false }) => (small ? '24px' : '40px')};
  min-height: ${({ small = false }) => (small ? '24px' : '40px')};

  ${spacingStyles}
`;
